import {Component, OnInit} from '@angular/core';
import {BackendService} from '../backend.service';
import {Registration} from '../datamodel/registration';
import {Faculty} from '../datamodel/faculty';
import {LeftMenuService} from '../left-menu.service';

interface RegistrationGroup {
  faculty: Faculty;
  registrations: Array<Registration>;
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
  public registrations: Registration[];
  public openedRegistrationsByFaculties: Array<[Faculty, Registration[]]>;
  public closedRegistrationsByFaculties: Array<[Faculty, Registration[]]>;
  public groupedRegistrations: {
    activeWithCurrentRound: RegistrationGroup[],
    activeWithNextRound: RegistrationGroup[],
    isInactiveOrFinished: RegistrationGroup[]
  };

  static compareUpcoming(a: Registration, b: Registration) {
    const result = a.upcomingRound().dateFrom.getTime() - b.upcomingRound().dateFrom.getTime();
    if (result === 0) {
      return CalendarComponent.compareRest(a, b);
    }
    return result;
  }

  static compareRest(a: Registration, b: Registration) {
      return a.id.localeCompare(b.id);
  }

  constructor(public backend: BackendService, public menu: LeftMenuService) {
  }

  ngOnInit() {
    this.backend.getRegistrations()
      .subscribe(registrations => {
        registrations = registrations.filter(r => r.status !== 'Closed');
        this.groupedRegistrations = {
          activeWithCurrentRound: this.groupByFaculties(registrations.filter(r => r.isActiveWithCurrentRound).sort(CalendarComponent.compareRest)),
          activeWithNextRound: this.groupByFaculties(registrations.filter(r => r.isActiveWithNextRound).sort(CalendarComponent.compareUpcoming)),
          isInactiveOrFinished: this.groupByFaculties(registrations.filter(r => r.isInactiveOrFinished).sort(CalendarComponent.compareRest))
        };
      });
    this.menu.addPath([]);
  }

  public groupByFaculties(registrations: Registration[]): RegistrationGroup[] {
    const result = new Array<RegistrationGroup>();

    let lastFacultyId: string | null = null;
    let lastItem: RegistrationGroup = null;

    registrations.forEach(reg => {
      if (!reg.faculty) {
        return;
      }
      if (lastFacultyId !== reg.faculty.id) {
        lastFacultyId = reg.faculty.id;
        lastItem = {
          faculty: reg.faculty,
          registrations: []
        };
        result.push(lastItem);
      }
      lastItem.registrations.push(reg);
    });
    return result;
  }
}
